import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Grid,
  Typography,
  Box,
  useTheme,
  useMediaQuery,
} from '@mui/material'
import {
  PageContainer,
  StyledCard,
  SectionHeader,
  PrimaryButton,
} from '../components/ui/StyledComponents'
import { useAuth } from '../context/AuthContext'
import { getTeacherAccessibleClasses, getClassDisplayName } from '../utils/classUtils'

function ClassesPage() {
  const { user } = useAuth()
  const [classes, setClasses] = useState([])
  const navigate = useNavigate()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

  console.log(classes)

  useEffect(() => {
    const fetchClasses = async () => {
      try {
        const data = await getTeacherAccessibleClasses(user?.id, '*');
        setClasses(data);
      } catch (error) {
        console.error('Error fetching classes:', error);
        setClasses([]);
      }
    }

    if (user?.id) {
      fetchClasses();
    }
  }, [user?.id])

  const handleClassClick = (classId) => {
    navigate(`/class/${classId}`) // Navigate to a class details page
  }

  return (
    <PageContainer>
      <Grid container spacing={{ xs: 2, sm: 3 }}>
        <Grid item xs={12}>
          <SectionHeader sx={{ fontSize: { xs: '1.5rem', sm: '2rem', md: '2.125rem' } }}>
            My Classes
          </SectionHeader>
        </Grid>

        <Grid item xs={12}>
          <StyledCard>
            <TableContainer
              sx={{
                overflowX: { xs: 'auto', sm: 'visible' },
                '&::-webkit-scrollbar': {
                  height: { xs: '6px', sm: '0px' },
                },
                '&::-webkit-scrollbar-track': {
                  backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.05)' : 'rgba(0, 0, 0, 0.05)',
                },
                '&::-webkit-scrollbar-thumb': {
                  backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.2)' : 'rgba(0, 0, 0, 0.2)',
                  borderRadius: '3px',
                },
              }}
            >
              <Table sx={{ minWidth: { xs: 600, sm: 'auto' } }}>
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ fontSize: { xs: '0.875rem', sm: '1rem' }, whiteSpace: 'nowrap' }}>
                      Class Name
                    </TableCell>
                    <TableCell sx={{ fontSize: { xs: '0.875rem', sm: '1rem' }, whiteSpace: 'nowrap', display: { xs: 'none', md: 'table-cell' } }}>
                      Shift
                    </TableCell>
                    <TableCell sx={{ fontSize: { xs: '0.875rem', sm: '1rem' }, whiteSpace: 'nowrap', display: { xs: 'none', lg: 'table-cell' } }}>
                      Start Time
                    </TableCell>
                    <TableCell sx={{ fontSize: { xs: '0.875rem', sm: '1rem' }, whiteSpace: 'nowrap', display: { xs: 'none', lg: 'table-cell' } }}>
                      End Time
                    </TableCell>
                    <TableCell sx={{ fontSize: { xs: '0.875rem', sm: '1rem' }, whiteSpace: 'nowrap' }}>
                      Actions
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {classes.length > 0 ? (
                    classes.map((classItem) => (
                      <TableRow key={classItem.id}>
                        <TableCell sx={{ fontSize: { xs: '0.875rem', sm: '1rem' } }}>
                          <Box>
                            <Typography variant="body2" fontWeight="medium" sx={{ fontSize: { xs: '0.875rem', sm: '1rem' } }}>
                              {getClassDisplayName(classItem)}
                            </Typography>
                            {isMobile && (
                              <>
                                <Typography variant="caption" color="textSecondary" sx={{ display: 'block', mt: 0.5, fontSize: '0.75rem' }}>
                                  Shift: {classItem.shift || 'N/A'}
                                </Typography>
                                <Typography variant="caption" color="textSecondary" sx={{ display: 'block', mt: 0.5, fontSize: '0.75rem' }}>
                                  Time: {classItem.start_time} - {classItem.end_time}
                                </Typography>
                              </>
                            )}
                          </Box>
                        </TableCell>
                        <TableCell sx={{ fontSize: { xs: '0.875rem', sm: '1rem' }, display: { xs: 'none', md: 'table-cell' } }}>
                          {classItem.shift || 'N/A'}
                        </TableCell>
                        <TableCell sx={{ fontSize: { xs: '0.875rem', sm: '1rem' }, display: { xs: 'none', lg: 'table-cell' } }}>
                          {classItem.start_time}
                        </TableCell>
                        <TableCell sx={{ fontSize: { xs: '0.875rem', sm: '1rem' }, display: { xs: 'none', lg: 'table-cell' } }}>
                          {classItem.end_time}
                        </TableCell>
                        <TableCell sx={{ fontSize: { xs: '0.875rem', sm: '1rem' } }}>
                          <PrimaryButton
                            variant="contained"
                            onClick={() => handleClassClick(classItem.id)}
                            fullWidth={isMobile}
                            sx={{
                              fontSize: { xs: '0.75rem', sm: '0.875rem' },
                              padding: { xs: '8px 12px', sm: '10px 16px' },
                              minWidth: { xs: 'auto', sm: '120px' },
                            }}
                          >
                            {isMobile ? 'View' : 'View Details'}
                          </PrimaryButton>
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell 
                        colSpan={5} 
                        align="center"
                        sx={{ 
                          py: { xs: 3, sm: 4 },
                          fontSize: { xs: '0.875rem', sm: '1rem' },
                        }}
                      >
                        No classes to display
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </StyledCard>
        </Grid>
      </Grid>
    </PageContainer>
  )
}

export default ClassesPage
